import { ThemeProvider } from "@greco/components";
import LoadingOverlay from "components/LoadingOverlay";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SplitPane, { Pane } from "split-pane-react";
import "split-pane-react/esm/themes/default.css";
import { useAppStore } from "store/AppStore";
import { useInsurerReportsStoreState } from "store/InsurerReportsStore";
import {
  ExportExcel,
  ExportExcelHandle,
} from "./InsurerReportEntriesGrid/ExportExcel";
import InsurerReportEntryGrid from "./InsurerReportEntriesGrid/InsurerReportEntryGrid";
import InsurerReportGrid from "./InsurerReportsGrid/InsurerReportGrid";
import Navigation from "./Navigation";
import i18n from "i18n";

const InsurerReports = () => {
  const [sizes, setSizes] = useState([100, "30%", "auto"]);
  const [{ appState }, { setAppStoreValue }] = useAppStore();
  const { t } = useTranslation();
  const refExcelExport = useRef<ExportExcelHandle>(null);

  const {
    insurerReportsLoadStatus,
    insurerReportEntriesLoadStatus,
    deleteInsurerReportStatus,
    matchInsurerReportStatus,
    importInsurerReportStatus,
    matchInsurerReportEntryStatus,
    infoInsurerReportEntryStatus,
  } = useInsurerReportsStoreState();

  const isLoading =
    insurerReportsLoadStatus === "loading" ||
    insurerReportEntriesLoadStatus === "loading" ||
    deleteInsurerReportStatus === "loading" ||
    matchInsurerReportStatus === "loading" ||
    importInsurerReportStatus === "loading" ||
    matchInsurerReportEntryStatus === "loading" ||
    infoInsurerReportEntryStatus === "loading";

  useEffect(() => {
    setAppStoreValue(
      "headerTitle",
      t("pct.premiumCollectionTool.label") +
        " - " +
        t("pct.insurerReports.label")
    );
  }, [i18n.language]);

  return (
    <>
      <ThemeProvider isDarkMode={appState.darkMode}>
        <Navigation refExcelExport={refExcelExport} />
      </ThemeProvider>

      <SplitPane
        split="horizontal"
        sizes={sizes}
        onChange={setSizes}
        resizerSize={5}
        sashRender={() => <></>}
        className="split-pane"
        style={{
          height: "calc(100% - 90px)",
        }}
      >
        <Pane minSize={"7%"} maxSize="93%">
          <InsurerReportGrid />
        </Pane>
        <Pane minSize={"7%"} maxSize="93%">
          <InsurerReportEntryGrid />
        </Pane>
      </SplitPane>

      <ExportExcel ref={refExcelExport} />

      {isLoading ? <LoadingOverlay /> : null}
    </>
  );
};

export default InsurerReports;
